import * as React from "react";
import styled from "styled-components";
import FormUserSearch from "../form/customer/FormCustomerSearch";
import { BORDER_RADIUS } from "../constants";

interface Props
{
    openCustomerAddForm: () => void;
}

const arrowSize = ".85rem";
const arrowTop = "-.84rem";
const arrowColor = "#fff"

const Root = styled.div`
    background-color: #fff;
    border-radius: ${BORDER_RADIUS};
    position: absolute;
    min-width: 35rem;
    top: 3rem;
    right: 0;

    :after {
        content: "";
        position: absolute;
        top: ${arrowTop};
        right: 1rem;
        width: 0;
        height: 0;
        border-bottom: solid ${arrowSize} ${arrowColor};
        border-left: solid ${arrowSize} transparent;
        border-right: solid ${arrowSize} transparent;
      }
`

const handleClick = (e: React.MouseEvent) => e.nativeEvent.stopPropagation();

const ArrowMenuUserSearch = (props: Props) => (
    <Root onClick={handleClick}>
        <FormUserSearch openAddCustomerForm={props.openCustomerAddForm} />
    </Root>
)

export default ArrowMenuUserSearch;
